import { Injectable, Output, EventEmitter } from '@angular/core';
import { ActionMessage, ActionMessageType } from '../../models/common/action-message';
import { HttpErrorResponse } from '@angular/common/http';
import { IHttpCustomError } from '../../models/common/i-http-custom-error';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  constructor(
    public router: Router,
  ) {
    this.actionMessage = new ActionMessage();
    setInterval(() => {
      this.checkConnection();
    }, 5000);
  }

  @Output() actionMessageShowEvent = new EventEmitter();
  @Output() actionMessageHideEvent = new EventEmitter();

  public actionMessage: ActionMessage;
  private connectionFailed = false;

  public showActionMessage(actionMessage: ActionMessage): void {
    this.actionMessage = actionMessage;
    this.actionMessageShowEvent.emit();
  }

  public showHttpErrorMessage(httpError: HttpErrorResponse): void {
    this.actionMessage = this.getHttpErrorMessage(httpError);
    if (this.actionMessage !== null) {
      this.actionMessageShowEvent.emit();
    }
  }

  public hideActionMessage(): void {
    this.actionMessageHideEvent.emit();
  }

  private getHttpErrorMessage=(httpErrorResponse: HttpErrorResponse): ActionMessage => {
    let message: ActionMessage;
    const customError: IHttpCustomError = httpErrorResponse.error;
    switch (httpErrorResponse.status) {
      case 400: {
        switch (customError.code) {
          case 1003:
            {
              message = {
                message: customError.errorMessage,
                messageType: ActionMessageType.Failure
              };
              break;
            }
          case 1004:
            {
              message = {
                message: customError.errorMessage,
                messageType: ActionMessageType.Failure
              };
              break;
            }
          case 1005:
            {
              message = {
                message: customError.errorMessage,
                messageType: ActionMessageType.Failure
              };
              break;
            }
          default:
            {
              message = {
                message: 'Something went wrong! Please contact admin.',
                messageType: ActionMessageType.Failure
              };
              break;
            }
        }
        break;
      }
      default: {
        message = {
          message: 'Something went wrong! Please contact admin.',
          messageType: ActionMessageType.Failure
        };
        break;
      }
    }

    return message;
  }

  private checkConnection=(): void =>{
    if (navigator.onLine) {
      if (this.connectionFailed) {
        this.connectionFailed = false;
        this.hideActionMessage();
      }
    } else {
      if (!this.connectionFailed) {
        this.showActionMessage({
          message: 'Please check your internet connection.',
          messageType: ActionMessageType.Failure
        });
        this.connectionFailed = true;
      }
    }
  }
}
